export const transformProductsPerTraveler = (products = [], travelerId) => {
  return products.map((product) => {
    const { priceRaw, price, ...rest } = product.travelers?.find(
      (unit) => unit.travelerId === travelerId,
    );

    const filteredRest = Object.fromEntries(
      Object.entries(rest).filter(([, value]) => !Number.isNaN(value)),
    );

    return {
      travelerId,
      id: product.id,
      markup: product.markup,
      name: product.name,
      title: product.title,
      priceRaw: priceRaw || price?.price?.value || 0,
      ...filteredRest,
    };
  });
};

export const getProductsPerTraveler = (products = [], travelerPrices = []) => {
  return travelerPrices.map((traveler) => {
    const filteredProducts = products.filter((product) =>
      product.travelers?.some((unit) => unit.travelerId === traveler.travelerId),
    );
    const transformedProducts = transformProductsPerTraveler(filteredProducts, traveler.travelerId);
    return { ...traveler, products: transformedProducts };
  });
};

export const getExtraProducts = (products = []) =>
  products.filter((product) => product.travelers?.length === 0);

export const getTravelerProductsTotalPrice = (
  totalPriceSum,
  products = [],
  excludedProductsFromMarkup = [],
) =>
  products.reduce((total, { id, priceRaw, markup }) => {
    if (excludedProductsFromMarkup.includes(String(id))) {
      return total + (priceRaw - (markup ?? 0));
    }

    return total + priceRaw;
  }, totalPriceSum);

export const getExtraProductsTotal = (products = [], excludedProductsFromMarkup = []) =>
  products.reduce((total, { id, price, markup }) => {
    if (excludedProductsFromMarkup.includes(String(id))) {
      return total + (price - (markup ?? 0));
    }

    return total + price;
  }, 0);

export const sortProductsByAlpabethicOrder = (products = []) =>
  products.sort((a, b) => a.title?.localeCompare(b.title));

export const getTaxesAndFeesTotalWithoutBreakdown = (vat, markup) => (vat ?? 0) + (markup ?? 0);

export const getTaxesAndFeesTotalWithBreakdown = (taxesAndFees) => {
  const taxes = taxesAndFees.map((obj) => obj.taxes).flat();
  return taxes.reduce((total, { code, amount }) => (code !== 'BASE' ? total + amount.value : 0), 0);
};

export const getTaxesAndFeesTotal = (taxesAndFees = [], vat, markup) =>
  taxesAndFees.length > 0
    ? getTaxesAndFeesTotalWithBreakdown(taxesAndFees)
    : getTaxesAndFeesTotalWithoutBreakdown(vat, markup);

export const getTaxesAndFeesTotalPriceCarrierSpecific = (taxesAndFees = [], vat) =>
  getTaxesAndFeesTotalWithBreakdown(taxesAndFees) + (vat ?? 0);

export const getProductsTotalMarkup = (products = []) =>
  products.reduce((total, { markup }) => total + (markup ?? 0), 0);

export const getTravelerTotalMarkupFee = (travelers = []) =>
  travelers.reduce((total, traveler) => {
    return total + (traveler.markup ?? 0);
  }, 0);

export const isSpecificProductsSelected = (id, productIds = []) => productIds.includes(id);

export const sortCarriers = (carrierPriceBreakdown = [], uniqueCarriers) => {
  return carrierPriceBreakdown.sort((pricebreakdownA, pricebreakdownB) => {
    const indexA = uniqueCarriers.findIndex(
      (uniqueCarrier) => uniqueCarrier.name === pricebreakdownA.carrier?.name,
    );
    const indexB = uniqueCarriers.findIndex(
      (uniqueCarrier) => uniqueCarrier.name === pricebreakdownB.carrier?.name,
    );

    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }

    return indexA === -1 ? 1 : -1;
  });
};
